/*
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2022-05-17 21:58:18
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2022-12-19 15:22:41
 * @FilePath: \web-qiankun\main\src\api\main\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 项目所需接口
import request from '@/utils/request'
// 获取系统菜单列表
export function AuthNavigationbar (data) {
  return request({
    url: '/sso/auth/authNavigationbar/list',
    method: 'get',
    data
  })
}
// 获取审批跳转页面地址
export function portalurl (data) {
  return request({
    url: '/portal/route/get/url/info',
    method: 'post',
    data
  })
}
// 获取审批个数（包含审核）
export function CountApprovalRecordPendind (data) {
  return request({
    url: '/workflow/approvalRecord/all/countApprovalRecordPendind',
    method: 'post',
    data
  })
}

// 获取通知个数
export function countApprovalRecordNotifier (data) {
  return request({
    url: '/workflow/approvalRecord/countApprovalRecordNotifier',
    method: 'post',
    data
  })
}

// 审批类型
export function getServiceList (data) {
  return request({
    url: '/workflow/workflowTemplate/getServiceList',
    method: 'post',
    data
  })
}

export function login (data) {
  return request({
    url: '/sso/user/userLogin',
    method: 'post',
    data
  })
}
